import React from 'react'
import { connect, useDispatch } from 'react-redux';
import * as $ from 'jquery';
import { orderPaymentUpdate, orderPaymentsHistoryLoad } from '../../../../redux/actions/order/orderPaymentActions';
import SaleRefundList from './SaleRefundList';
import useStoreAllowedPaymentMethods from '../../../../other/helperHooks/useStoreAllowedPaymentMethods';
import { humanize } from '../../../../itrust_common/components/HelperFunctions';

function PaymentsButtonForm(props) {
  const { payments_by_type, order, history_payments } = props
  const dispatch = useDispatch()
  const AllowedPaymentMethods = useStoreAllowedPaymentMethods()
  const NonOnlinePaymentMethods = AllowedPaymentMethods.filter(item => !['online', 'device', 'link'].includes(item.value))

  const handlePaymentSubmit = (data) => {
    dispatch(orderPaymentUpdate(order.id, data))
  }

  const handlePaymentEditCancel = () => {
    $("#orderPaymentsForm-modal").modal('hide')
  }
  const handleViewHistory = () => {
    dispatch(orderPaymentsHistoryLoad(order.id, {}))
    $("#orderPaymentsForm-modal").modal('hide')
    $("#orderPaymentsHistory-modal").modal('show')
  }

  return (
    <div className="inner-modal">
      <div className="modal refund-modal" id="orderPaymentsForm-modal">
        <div className="modal-dialog">
          <div className="modal-content border-0 shadow">
            <div className="modal-header p-5 align-items-center">
              <h5 className="modal-title"> Payment Details </h5>
              <div>
                <button type="button" className="btn btn-outline-primary mr-3" onClick={handleViewHistory}>
                  View History
                </button>
                <button type="button" className="btn btn-outline-primary mr-3" onClick={handlePaymentEditCancel}>
                  Cancel
                </button>
              </div>
            </div>
            <div className="modal-body p-0">
              <SaleRefundList type="sale" handlePaymentSubmit={handlePaymentSubmit} payments={payments_by_type.sales} AllowedPaymentMethods={AllowedPaymentMethods} NonOnlinePaymentMethods={NonOnlinePaymentMethods} />
            </div>
          </div>
        </div>
      </div>

      <div className="modal refund-modal" id="orderPaymentsHistory-modal">
        <div className="modal-dialog">
          <div className="modal-content border-0 shadow" style={{ maxHeight: '300px', overflowY: 'auto' }}>
            <div className="modal-header p-5 align-items-center" style={{ position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 1 }}>
              <h5 className="modal-title"> Payment History </h5>
              <div>
                <button type="button" className="btn btn-outline-primary mr-3" onClick={() => {
                  $("#orderPaymentsHistory-modal").modal('hide')
                  $("#orderPaymentsForm-modal").modal('show')
                }}>
                  Back
                </button>
              </div>
            </div>
            <div className="modal-body p-5">
              {history_payments && history_payments.map((version, idx) => {
                 let event = version.event;
                 let changes = version.formatted_changes || version.changed_values || {};
                 return (
                   <div key={idx} className="mb-4 pb-4 border-primary" style={{borderLeft: '1px solid primary', paddingLeft: '10px'}}>
                     <h6 className="text-capitalize bg-primary-light rounded d-inline-block px-3 py-2">Event: {event}</h6>
                     <p className="text-muted small mb-2">Date: {new Date(version.created_at).toLocaleString()}</p>
                        {(event === 'update' || event === 'destroy') && (
                          <div className="mt-2 claim-history-details">
                            {Object.keys(changes).map(key => {
                              const val = changes[key];

                              // Skip null, undefined, and empty values
                              if (
                                val === null ||
                                val === undefined ||
                                val === ''
                              ) {
                                return null;
                              }

                              // Handle before/after changes
                              if (
                                typeof val === 'object' &&
                                ('before' in val || 'after' in val)
                              ) {
                                const before = val.before;
                                const after = val.after;

                                // Skip if both values are empty
                                if (
                                  (before === null || before === undefined || before === '') &&
                                  (after === null || after === undefined || after === '')
                                ) {
                                  return null;
                                }

                                return (
                                  <div className="claim-history-change d-flex align-items-center" key={key}>
                                    <strong>{`${humanize(key)}:  `}</strong>

                                    <div className="claim-history-values ml-2">
                                      {before !== null &&
                                      before !== undefined &&
                                      before !== '' ? (
                                        <span className="claim-history-old">
                                          {String(before)}
                                        </span>
                                      ) : null}

                                      {before !== null &&
                                      before !== undefined &&
                                      before !== '' &&
                                      after !== null &&
                                      after !== undefined &&
                                      after !== '' && (
                                        <span className="claim-history-arrow">
                                          →
                                        </span>
                                      )}

                                      {after !== null &&
                                      after !== undefined &&
                                      after !== '' ? (
                                        <span className="claim-history-new text-primary bg-primary-light px-2 py-1 rounded">
                                          {String(after)}
                                        </span>
                                      ) : null}
                                    </div>
                                  </div>
                                );
                              }

                              // Handle regular values
                              return (
                                <div className="claim-history-change" key={key}>
                                  <strong>{humanize(key)}:</strong>{' '}
                                  {String(val)}
                                </div>
                              );
                            })}

                            <div className="claim-history-updated-by">
                              <strong>Updated By:</strong> {version.user_name || '-'}
                            </div>
                          </div>
                        )}
                   </div>
                 )
              })}
              {(!history_payments || history_payments.length === 0) && (
                <div className="text-center text-muted">No history found.</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  const { orderPayment, order } = state
  return {
    payments_by_type: orderPayment.payments_by_type,
    history_payments: orderPayment.history_payments,
    order: order.order,
  }
}

export default connect(mapStateToProps)(PaymentsButtonForm)